import './fund-card.styles'
import './fund-card.scss'

import { ApiAsset } from '@/api/_legacy/generated-api'

import { Space } from '../..'
import PillLabelsStack from '../pill-labels-stack'

export type FundCardProps = {
  alerts?: string[]
  fund: ApiAsset
  isSelected?: boolean
  onClickFund?: (fundId: string) => void
}

export const FundCard = ({ alerts, fund, isSelected, onClickFund }: FundCardProps) => {
  const containerAlert = alerts && alerts.length > 0 ? 'alert' : ''
  const containerStyle = isSelected ? 'active' : ''

  return (
    <li className={`fund-item ${containerAlert} ${containerStyle}`}>
      <Space mx={4} onClick={() => onClickFund(fund.assetId)}>
        <Space isflex flexDirection="column" py={4}>
          <PillLabelsStack labels={alerts} py={2} />
          <div className="name">{fund.name}</div>
          <div className="isin">{fund.isinCode}</div>
        </Space>
      </Space>
    </li>
  )
}
